import { initNavi } from './modules/_navi';
import { initInview } from './modules/_inview';
import { initTicker } from './modules/_ticker';
import { initAccordion } from './modules/_accordion';
import { initSlider } from './modules/_slider';

const init = () => {
    initInview();
    initNavi();
    initTicker();
    initAccordion();
    initSlider();
};

window.addEventListener('load', init);